import React, { useCallback, useEffect, useState } from 'react';
import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Flex,
	Icon,
	Image,
	Text
} from '@chakra-ui/react';
import { FiArrowLeft, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import { add, format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { formatPrice } from '../../../utils/format';

import {  Container,  Content, Header, LancamentoContent, LancamentoItem } from './styles';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';

interface ModalParams {
	id?: string;
	onClose: any;
	isVisible: boolean;
	lancamento: FinJsonDTO;
}

const ModalLancamentoDetail: React.FC<ModalParams> = ({
  id = 'modalLancamentoDetalhe',
  onClose = () => {},
  isVisible,
	lancamento,
}) => {
  const handleOutSideClick = useCallback(
    (e: any) => {
      if (e.target.id === id) {
        onClose();
      }
    },
    [id, onClose],
  );

	useEffect(() => {
	}, []);

  const [visible, setVisible] = useState<boolean>(isVisible);

  return (
    <Container id="modalLancamentoDetalhe" onClick={handleOutSideClick}>
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <button
            onClick={() => {
              setVisible(false);
              setTimeout(() => {
                onClose();
              }, 300);
            }}
          >
            <FiArrowLeft /> Voltar
          </button>
        </Header>

        <LancamentoContent>
					<LancamentoItem>
						<Flex><h1>Usuário:</h1>&nbsp;<span>{lancamento.user_nome}</span></Flex>
					</LancamentoItem>

					<LancamentoItem>
						<h2>Nro: <span>{lancamento.doc}</span></h2>
						<h2>Data:
							<span>
								{format(add(new Date(lancamento.data), { days: 1 }),
									" dd'/'MM'/'Y", { locale: ptBR })}
							</span>
						</h2>

						<Flex align="center">
							<h2>Baixado: </h2>
							{lancamento.baixado 
								? <Icon as={FiCheckCircle} fontSize={18} color="blue.500" />
								: <Icon as={FiXCircle} fontSize={18} color="red.600" />
							}
						</Flex>

						<h2>Valor: <span>{formatPrice(lancamento.vlr_doc)}</span></h2>
						<h2>Obs: <span>{lancamento.obs}</span></h2>
					</LancamentoItem>

					<LancamentoItem>
						{lancamento.cliente ? (
							<>
								<h1>Cliente</h1>
								<h2>{lancamento.cliente.nome}</h2>
								<h2>{lancamento.cliente.doc}</h2>
								<h2>{lancamento.cliente.phone}</h2>
								<h2>{lancamento.cliente.cid}</h2>
							</>
						) : (
							<h1>Sem Cliente.</h1>
						)}
					</LancamentoItem>

					<LancamentoItem>
						<h1>Operação</h1>
						<h2>{lancamento.operacao.nome}</h2>
						<h2>{lancamento.operacao.type_nome}</h2>
					</LancamentoItem>

					{(lancamento.documentos && lancamento.documentos.length > 0) && (
						<LancamentoItem>
							<h1>Documentos</h1>
							<Accordion allowMultiple>
								{lancamento.documentos.map(doc => {
									return (
										<AccordionItem
											key={doc.id}
											border={0}
											bg="gray.50"
											borderRadius={4}
											mb={2}
										>
											<AccordionButton pl={0} pr={2} _hover={{ background: "transparent" }}>
												<Box as="h2" flex='1' textAlign='left'>
													<span>Cod: {doc.id}</span>
												</Box>
												<AccordionIcon color="blue.500" />
											</AccordionButton>

											<AccordionPanel px={2} pt={-2} pb={4}>
												<h2>Tipo: <span>{doc.type_nome}</span></h2>
												<h2>Parcela: <span>{doc.parcela ? doc.parcela : '--'}</span></h2>
											</AccordionPanel>
										</AccordionItem>
									)
								})}
							</Accordion>
						</LancamentoItem>
					)}

					{(lancamento.lancamentos && lancamento.lancamentos.length > 0) && (
						<LancamentoItem>
							<h1>Lançamentos</h1>
							<Accordion allowMultiple>
								{lancamento.lancamentos?.map(lancamentoo => {
									return (
										<AccordionItem
											key={lancamentoo.id}
											border={0}
											bg="gray.50"
											borderRadius={4}
											mb={2}
										>
											<AccordionButton pl={0} pr={2} _hover={{ background: "transparent" }}>
												<Box as="h2" flex='1' textAlign='left' pl={0}>
													<Flex>
														<h2>Operação: <span>{lancamentoo.vlr_cred > 0 ? 'Crédito' : 'Débito'}</span></h2>
														<h2>Valor: <span>{formatPrice(lancamentoo.vlr_cred + lancamentoo.vlr_deb)}</span></h2>
													</Flex>
												</Box>
												<AccordionIcon color="blue.500" />
											</AccordionButton>

											<AccordionPanel px={2} pt={-2} pb={4}>
												{/* CAIXA */}
												<Flex flexDir="column">
													<Text color="gray.700" fontWeight={500}>Caixa:</Text>

													<Flex
														flexDir="column"
														borderWidth={2}
														borderColor="gray.100"
														borderRadius={8}
														ml={2}
														py={1}
														mb={1}
													>
														<h2>Usuário: <span>{lancamentoo.caixa.user_nome}</span></h2>
														<h2><span>{lancamentoo.caixa.nome}</span></h2>
														<Flex align="center">
															<h2>Compensado: </h2>
															{lancamentoo.caixa.compensado 
																? <Icon as={FiCheckCircle} fontSize={18} color="blue.500" />
																: <Icon as={FiXCircle} fontSize={18} color="red.600" />	
															}
														</Flex>
													</Flex>
												</Flex>

												{/* LANÇAMENTO */}
												{(lancamentoo.conta && lancamentoo.conta.length > 0) && (
													<Flex flexDir="column">
														<Text color="gray.700" fontWeight={500}>Contas:</Text>

														{/* CONTA */}
														{lancamentoo.conta.map(con => {
															return (
																<Flex
																	key={con.id}
																	flexDir="column"
																	borderWidth={2}
																	borderColor="gray.100"
																	borderRadius={8}
																	ml={2}
																	py={1}
																	mb={1}
																>
																	<h2><span>{con.id} - {con.nome}</span></h2>

																	<Flex>
																		<h2>Operação: <span>{con.vlr_cred > 0 ? 'Crédito' : 'Débito'}</span></h2>
																		<h2>Valor: <span>{formatPrice(con.vlr_cred + con.vlr_deb)}</span></h2>
																	</Flex>
																</Flex>
															)
														})}
													</Flex>	
												)}

												{/* LANCAMENTO - PAY */}
												<Flex flexDir="column">
													<Text color="gray.700" fontWeight={500}>Forma Pagamento:</Text>

													<Flex
														flexDir="column"
														borderWidth={2}
														borderColor="gray.100"
														borderRadius={8}
														ml={2}
														py={1}
														mb={1}
													>
														<h2>Cod: <span>{lancamentoo.pay.cod_auth}</span></h2>

														<Flex align="center" pl={2}>
															<Image src={lancamentoo.pay.url_pay} objectFit='cover' w='25px' h="20px" />
															<h2>{lancamentoo.pay.name_pay}</h2>
														</Flex>
													</Flex>
												</Flex>
											</AccordionPanel>
										</AccordionItem>
									)
								})}
							</Accordion>
						</LancamentoItem>
					)}
        </LancamentoContent>
      </Content>
    </Container>
  );
};

export default ModalLancamentoDetail;
